import styled from "@emotion/styled";

export const LoaderWrapper = styled.div`
  position: absolute;
  right: 0;
  display: flex;

  justify-content: space-evenly;

  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: #e1d9d6;
`;
